export default {"src":"/_next/static/media/icon-ps-42.a3fc98f0.svg","height":42,"width":124};